module.exports = __webpack_public_path__ + "media/images/lufthansa/confirmation/confirmation-card-cc292b23745b4c7e1bd2fd87345f0d93.jpg";